import React, {useState} from 'react';
import IconArrowTopRight from '../icon/IconArrowTopRight';
import GhostContentAPI, {PostOrPage, PostsOrPages, Tag} from '@tryghost/content-api'
import Skeleton from '../../ui/skeleton/Skeleton';
import cn from 'classnames';

interface News {
  title: string
  url: string
  img: string
  button: string
  tag?: string
}

function capitalize(str?: string): string | undefined {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
}

function createNews(page: PostOrPage): News | null {
  // we always put the url to follow and the action into the excerpt of the page, split by |.
  // for example, https://workshopbutler.com|Check it out
  if (page.title && page.feature_image && page.url && page.custom_excerpt) {
    const [url, button] = page.custom_excerpt.split('|');
    const tag = page.tags?.filter((x: Tag) => x.name !== '#app_promo').map((x: Tag) => capitalize(x.name)).find(() => true);
    return {
      title: page.title,
      url,
      img: page.feature_image,
      button,
      tag
    };
  }
  return null;
}

export default function Promo() {
  const [api] = useState(new GhostContentAPI({
    url: 'https://workshopbutler.com/blog',
    key: 'f1c7cc89dc7e6f45b10c44e0cd',
    version: "v3"
  }));
  const [news, setNews] = useState<News | null>(null);
  const [loading, setLoading] = useState(true);
  const [imageLoading, setImageLoading] = useState(true);

  React.useEffect(() => {
    api.pages.browse({
      include: 'tags',
      filter: 'tag:hash-app_promo',
      limit: 1,
    }).then((pages: PostsOrPages) => {
      if (pages.length > 0) {
        setNews(createNews(pages[0]));
      }
    }).finally(() => {
      setLoading(false);
    });
  }, [api]);

  const skeleton = (
    <div className="p-10 flex flex-col justify-between h-full">
      <div>
        <Skeleton/>
        <Skeleton className="mt-6"/>
        <Skeleton className="mt-6"/>
        <Skeleton className="mt-6"/>
      </div>
      <div>
        <Skeleton className="h-10"/>
        <Skeleton className="h-10 mt-6"/>
      </div>
    </div>
  );

  return (
    <>
      {loading && skeleton}
      {news &&
      <>
        {imageLoading && skeleton}
        <img
          className={cn('absolute inset-0 h-full w-full object-scale-down sm:object-cover rounded-r-lg',
            {'hidden': imageLoading})}
          src={news.img}
          alt={news.title}
          onLoad={() => setImageLoading(false)}
        />
        <div className={cn('rounded-br-lg bg-black bg-opacity-80 p-10 text-white absolute bottom-0 w-full',
          {'hidden': imageLoading})}>
          <h2 className="text-2xl font-extrabold">{news.title}</h2>
          <div className="flex flex-row mt-2">
            {news.tag &&
            <span className="rounded-md border px-2 py-0.5 border-white text-sm font-bold mr-4">{news.tag}</span>}
            <a href={news.url} target="_blank" rel="noreferrer">{news.button}&nbsp;<IconArrowTopRight
              className="w-5 h-5 text-white inline"/></a>
          </div>
        </div>
      </>
      }
      {!news && !loading &&
      <img
        className="absolute inset-0 h-full w-full object-scale-down sm:object-fill rounded-r-lg"
        src="https://res.cloudinary.com/wsb/image/upload/v1625659301/app/kcbfwulstvbagcvxmq99.png"
        alt="Workshop Butler App"
      />
      }
    </>
  )
}
